import { Modal, Button, Table, InputGroup, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Select from 'react-select';
import { Popover } from 'react-tiny-popover';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import currency from 'currency.js';
import DateTime from 'react-datetime';
import moment from 'moment';
import { IoCheckmarkDoneSharp } from 'react-icons/io5';

import { CustomInput } from '../utils/CustomInput';
import { useAuth } from '../../hooks/useAuth';
import '../../assets/scss/scoped/issueItem.scss';
import ConfirmDialog from '../ConfirmDialogue';
import { fetchActionsUtil } from '../../utils/helpers';
import GetTemplateModal from './GetTemplateModal';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { CheckCircleIcon, DeleteIcon, EditIcon } from '../Icons';
import ModalLoader from '../utils/ModalLoader';
import NewRequisitionModal from '../Requisition/NewRequisition';
import { format } from 'date-fns';
import { VscClearAll } from 'react-icons/vsc';
import NewPurchaseRequisitionModal from '../Requisition/NewPurchaseRequisitionModal';

export const CreateProductionPlanModal = (props) => {
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [activeTableIndex, setActiveTableIndex] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedReceiver, setSelectedReceiver] = useState('');
  const [result, setResult] = useState();
  const [itemsRequested, setItemsRequested] = useState([]);
  const [showNewRequisitionModal, setShowNewRequisitionModal] = useState(false);
  const [showPurchaseRequisitionModal, setShowPurchaseRequisitionModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [allPlans, setAllPlans] = useState(props?.choosedItem || []);
  const [requisitionData, setRequisitionData] = useState([]);

  const { backendUrl, token, user } = useAuth();

  const initialValues = {
    Bar_Code: '',
    Item_Name: '',
    Item_Desc: '',
    Product_Name: '',
    Cat_Name: '',
    RequesterName: '',
    Requester: '',
    UnitCost: '',
    Date_Log: moment(new Date()),
    Quantity: '',
    UserName: '',
    plant: '',
    Plan_Name: '',
    Plan_Id: Date.now(),
    complete: true,
    Product_Model: '',
  };

  const handleInputChange = ({ index, name, value }) => {
    const oldTableData = tableData;
    oldTableData[index][name] = value;
    setTableData([...oldTableData]);
  };

  const [isLoadingAddToCart, setIsLoadingAddToCart] = useState(false);

  const plantLocal = JSON.parse(window.localStorage.getItem('plantDetails'));

  const fetchItems = async () => {
    const data = await fetchActionsUtil(
      `${backendUrl}/api/production/IssueTo_Officers`,
      'GET',
      token
    );
    data.staffs = data.staffs.map((el) => ({
      value: el.Staff_ID,
      label: el.Name,
    }));

    data.warehouse = [{ value: 'Sales', label: 'Sales' }].concat(
      ...data.warehouse.map((el) => ({
        value: el.W_ID,
        label: el.W_name,
      }))
    );

    return data;
  };

  const { data, isLoading } = useQuery(['GET_OTHERS'], () => fetchItems(), {
    enabled: true,
  });

  const sendProductLog = useMutation(
    (payload) =>
      fetchActionsUtil(`${backendUrl}/api/production/product-plan`, 'POST', token, payload),
    {
      onSuccess: ({ message, data }) => {
        toast.success('Successfully Created');

        formik.resetForm({
          values: {
            ...initialValues,
          },
        });

        setTableData([]);
        props.refetchMain();
        props.onHide();
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const editProductPlan = useMutation(
    (payload) =>
      fetchActionsUtil(`${backendUrl}/api/production/product-plan`, 'PUT', token, payload),
    {
      onSuccess: ({ message, data }) => {
        toast.success('Successfully Updated');

        props.onHide();
        props.refetchMain();
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const formik = useFormik({
    initialValues,
    validationSchema: tableData.length
      ? yup.object().shape({
          Bar_Code: yup.string().required('Bar Code is required'),
          Item_Name: yup.string().required('Item Name is required'),
          Quantity: yup.string().required('Quantity is required'),
          Product_Name: yup.string().required('Product is required'),
          Cat_Name: yup.string().required('Category by is required'),
        })
      : null,
    onSubmit: async (values) => {
      if (values.Plan_Name === '') {
        return toast.error('Enter plan name');
      }

      if (tableData.length) {
        if (values.Quantity === '') {
          return toast.error('Quantity is needed');
        }
      }

      if (tableData.length < 1 && allPlans.length < 1) {
        return toast.error('Please Add Items');
      }
      
      let submittingData = { tableData: [...allPlans, ...tableData,] };
      submittingData.tableData.map(ele => ele.Plan_Name = values.Plan_Name)
      if (props?.choosedItem) {
        if (
          await ConfirmDialog({
            title: 'Edit Production Plan',
            description: 'Are you sure you want to edit this production plan',
          })
        ) {
          return editProductPlan.mutate(submittingData);
        }
      } else {
        if (
          await ConfirmDialog({
            title: 'Save Production Plan',
            description: 'Are you sure you want to save this production plan',
          })
        ) {
          sendProductLog.mutate(submittingData);
        }
      }
    },
  });

  const handleAddToPlan = (quantity) => {
    console.log({allPlans, tableData}, quantity)
    if (tableData.length < 1) {
      return toast.error('Add Items');
    }

    let existingPlan = allPlans.find((el) => el.Bar_Code === tableData[0].Bar_Code);
    if (existingPlan) {
      return toast.error('Item already exists, consider editing');
    }
    tableData[0].Quantity = formik.values.Quantity || tableData[0].Quantity;
    setAllPlans((prev) => [...prev, ...tableData]);
    setTableData([]);
    const itemPlan = formik.values.Plan_Name;

    formik.resetForm();
    formik.setFieldValue('Plan_Name', itemPlan);
    setErrorMessage('');
  };

  const handleEditPlan = (plan) => {
    if (tableData.length) {
      return toast.error('Complete Initial table data');
    }
    console.log("plan to edit: ",plan)
    // addToTable(plan, plan.Quantity);
    handleSelectedItem(plan, plan.Quantity);
    setAllPlans(allPlans.filter((ele) => ele.Bar_Code !== plan.Bar_Code));
    setTableData([plan]);
  };

  useEffect(() => {
    let active = true;
    if (selectedReceiver === 'Sales') {
      setResult(data?.staffs);
    } else {
      setIsLoadingAddToCart(true);
      load();
      async function load() {
        setResult([]); // this is optional
        const { warehouseUsers } = await fetchActionsUtil(
          `${backendUrl}/api/warehouse/warehouse-users/${selectedReceiver}`,
          'GET'
        );

        if (!active) {
          return;
        }
        setResult(() =>
          warehouseUsers?.map((el) => ({
            value: el.Staff_ID,
            label: el.Name,
          }))
        );
        setIsLoadingAddToCart(false);
      }
    }
    return () => {
      active = false;
    };
  }, [selectedReceiver, data?.staffs, backendUrl]);

  const handleSelectedItem = (el, quantity = '') => {
    formik.setFieldValue('Bar_Code', el.Bar_Code);
    formik.setFieldValue('Item_Name', el.Item_Name);
    formik.setFieldValue('Product_Name', el.Product_Name);
    formik.setFieldValue('Cat_Name', el.Cat_Name);
    formik.setFieldValue('Product_Model', el?.Product_Model);
    formik.setFieldValue('UnitCost', el.UnitCost);
    formik.setFieldValue('UserName', user.username);
    formik.setFieldValue('plant', plantLocal.PLID);
    formik.setFieldValue('Quantity', quantity);
    formik.setFieldValue('Date_Log', el.Date_Log);
    if (props?.choosedItem) {
      addToTable(el, props?.choosedItem?.Quantity);
      el.plant = props?.choosedItem?.plant;
      el.Plan_Name = props?.choosedItem?.Plan_Name;
      el.Plan_Id = props?.choosedItem?.Plan_Id;
    }
    setSelectedItem(el);
    // setTableData([]);
    setShowItemsPopover(false);
    setErrorMessage(null);
    setItemsRequested([]);
  };

  useEffect(() => {
    if (props?.choosedItem) {
      const choosedItem = props?.choosedItem[0];
      // formik.setFieldValue('Bar_Code', choosedItem?.Bar_Code);
      // formik.setFieldValue('Item_Name', choosedItem?.Item_Name);
      // formik.setFieldValue('Item_Desc', choosedItem?.Item_Desc);
      // formik.setFieldValue('Product_Name', choosedItem?.Product_Name);
      // formik.setFieldValue('Cat_Name', choosedItem?.Cat_Name);
      // formik.setFieldValue('Product_Model', choosedItem?.Product_Model);
      // formik.setFieldValue('UnitCost', parseFloat(choosedItem?.UnitCost));
      formik.setFieldValue('Plan_Name', choosedItem?.Plan_Name);
      formik.setFieldValue('Plan_Id', choosedItem?.Plan_Id);
      formik.setFieldValue('complete', choosedItem?.complete);
      // formik.setFieldValue('Quantity', choosedItem?.Quantity);
      formik.setFieldValue('plant', choosedItem?.plant);
      // formik.setFieldValue('Date_Log', moment(new Date(choosedItem?.dueDate)));

      setTableData([]);
      // setAllPlans([props?.choosedItem])
    }
  }, [props?.choosedItem]);

  const onDelete = (barcode) => {
    const item = tableData.filter((d) => d.Bar_Code !== barcode);
    setTableData(item);
  };

  const addToTable = async (el, qty) => {
    if (el.Bar_Code === '') {
      return toast.error('Enter Item Id');
    }
    // continue from check-quantity-items not sending prod_profiles in payload
    if (qty === '') {
      return toast.error('Quantity is needed');
    }

    setIsLoadingAddToCart(true);
    const newData = { ...selectedItem, ...el, Quantity: qty };
    console.log(newData);
    try {
      const { message } = await fetchActionsUtil(
        `${backendUrl}/api/production/check-quantity-items/${plantLocal.PLID}`,
        'POST',
        token,
        newData
      );

      setIsLoadingAddToCart(false);

      if (message.length > 0) {
        setItemsRequested(message?.map((er) => er.item));
        setErrorMessage('Item Required not enough');
        // message?.map((er) => toast.error(er.message));
      } else {
        setErrorMessage(null);
        setItemsRequested([]);
      }
    } catch (error) {
      setIsLoadingAddToCart(false);
      // return;
    }
    // setErrorMessage(null);
    console.log(newData);
    setTableData([newData]);
  };

  const onKeyPressAction = (e) => {
    const code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      //Enter keycode
      addToTable(formik.values, e.target.value);
    }
  };

  const handleRequisitionRequest = () => {
    // const data = await fetchActionsUtil(
    //   `${backendUrl}/api/production/IssueTo_Officers`,
    //   'GET',
    //   token
    // );
    console.log(tableData);
    const requestData = tableData[0]?.prod_profiles || [];
    const requestItems = requestData.map((el) => ({
      barcode: el.item,
      Item_Name: el['item_data.Item_Name'],
      quantity: tableData[0].Quantity * el.quantity - el['item_data.Quantity'] || 1,
      unitCost: el.UnitCost,
      item_data: el.item_data,
    }));
    setRequisitionData(requestItems);
    return setShowPurchaseRequisitionModal(true);
  };

  return (
    <Modal
      onHide={props.onHide}
      show={props.show}
      backdropClassName={`global-backdrop`}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      dialogClassName='my-style-modal'
      animation={false}
      enforceFocus={false}
      size='xl'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div>
            <h1>{`${props?.choosedItem ? 'Edit' : 'Add'}`} Production Plan</h1>
          </div>

          <p>
            {`${props?.choosedItem ? 'Edit' : 'Add'}`} production plan by filling in the following
            forms.
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className='container'>
            <div>
              <div className='form-relative'>
                {/*  */}
                <div className='row'>
                  <div className='col-8'>
                    <CustomInput
                      name='Plan_Name'
                      placeholder='Enter Plan Name'
                      typeOfInput='text'
                      label='Tittle'
                      value={formik.values.Plan_Name}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className='col-4 mb-3'>
                    <label htmlFor='date' className='form-label'>
                      Item Code
                    </label>
                    <InputGroup>
                      <Form.Control
                        name='Bar_Code'
                        placeholder='Enter Item Code'
                        value={formik.values.Bar_Code}
                      />

                      <Popover
                        isOpen={showItemsPopover}
                        onClickOutside={() => setShowItemsPopover(false)}
                        content={() => <GetTemplateModal handleSelectedItem={handleSelectedItem} />}
                        position='bottom'
                      >
                        <InputGroup.Text onClick={() => setShowItemsPopover(!showItemsPopover)}>
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>

                    {formik.touched.Bar_Code && !!formik.errors.Bar_Code ? (
                      <span className='custom-invalid-feedback'>{formik.errors.Bar_Code}</span>
                    ) : null}
                  </div>
                </div>
                {/*  */}

                <div className='row'>
                  <div className='col-4 mb-3'>
                    <CustomInput
                      name='Item_Name'
                      placeholder='Enter Item Name'
                      typeOfInput='text'
                      label='Item Name'
                      disabled
                      value={formik.values.Item_Name}
                      onChange={(e) => {
                        setTableData((prev) => {
                          let oldData = prev[0];
                          return [{ ...oldData, Item_Name: e.target.value }];
                        });
                        formik.handleChange();
                      }}
                    />
                  </div>

                  <div className='col-4 mb-3'>
                    <CustomInput
                      name='Product_Name'
                      placeholder='Enter Product Name'
                      typeOfInput='text'
                      label='Product'
                      disabled
                      value={formik.values.Product_Name}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className='col-4 mb-3'>
                    <CustomInput
                      name='Cat_Name'
                      placeholder='Enter Cat Name'
                      typeOfInput='text'
                      label='Category'
                      disabled
                      value={formik.values.Cat_Name}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
                {/*  */}

                <div className='row'>
                  <div className='col-4 mb-3 d-flex align-items-end gap-2'>
                    <div className='flex-grow-1'>
                      <CustomInput
                        name='Quantity'
                        placeholder='Enter Quantity'
                        typeOfInput='text'
                        label='Quantity'
                        disabled={!formik.values.Bar_Code}
                        value={formik.values.Quantity}
                        onBlur={(e) => {
                          addToTable(formik.values, e.target.value);
                        }}
                        onKeyPress={onKeyPressAction}
                        onChange={(e) => {
                          formik.setFieldValue('Quantity', e.target.value, true);
                        }}
                      />
                      {formik.touched.Quantity && !!formik.errors.Quantity ? (
                        <span className='custom-invalid-feedback'>{formik.errors.Quantity}</span>
                      ) : null}
                    </div>

                    {formik.values.Product_Model || ''}
                  </div>

                  <div className='col-4 mb-3'>
                    <CustomInput
                      name='UnitCost'
                      placeholder='Enter Item Name'
                      typeOfInput='text'
                      label='Cost Price'
                      value={formik.values.UnitCost}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.UnitCost && !formik.errors.UnitCost ? (
                      <span className='custom-invalid-feedback'>{formik.errors.UnitCost}</span>
                    ) : null}
                  </div>
                  <div className='col-4'>
                    <label htmlFor='date' className='form-label'>
                      Due Date
                    </label>
                    <DateTime
                      timeFormat={false}
                      closeOnSelect={true}
                      closeOnClickOutside={true}
                      dateFormat='MMM DD, YYYY'
                      inputProps={{
                        className: `date-input form-control`,
                        placeholder: 'Select date',
                        readOnly: true,
                      }}
                      value={formik.values.Date_Log}
                      onChange={(date) => {
                        const formattedDate = date.format('YYYY-MM-DD');
                        formik.setFieldValue('Date_Log', formattedDate, true);
                        setTableData((prev) => {
                          let oldData = prev[0];
                          return [{ ...oldData, Date_Log: formattedDate }];
                        });
                      }}
                    />
                  </div>
                </div>

                {/*  */}
                {/* Table */}
                <Table responsive borderless striped className='product-table'>
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>Item Code</th>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th>Cost Price</th>
                      <th>Due date</th>
                      <th>Action</th>
                      {/* <th>Unit Cost</th>
                        <th>Sub Total</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {allPlans.length > 0 &&
                      allPlans.map((el, index) => {
                        console.log(el, "================================")
                        return (
                          <tr key={index} className=''>
                            <td>{index + 1}</td>
                            <td>{el.Bar_Code}</td>
                            <td>{el.Item_Name}</td>
                            <td>{el.Quantity}</td>
                            <td>
                              {currency(el.UnitCost, {
                                symbol: '',
                              }).format()}
                            </td>
                            <td>{new Date(el?.Date_Log).toLocaleDateString()}</td>
                            <td>
                              <button
                                title='Edit plan'
                                onClick={() => handleEditPlan(el)}
                                className='mx-2'
                              >
                                <EditIcon />
                              </button>
                              <button
                                title='Delete plan'
                                onClick={async () => {
                                  try {
                                    setAllPlans((prev) =>
                                      prev.filter((plan, cIndex) => cIndex !== index)
                                    );
                                    await fetchActionsUtil(
                                      `${backendUrl}/api/production/product-plan/${el.plant}/${
                                        el.Plan_Id
                                      }/${el.Bar_Code}`,
                                      'DELETE',
                                      token
                                    );
                                  } catch (error) {
                                    console.error(error.message);
                                  }
                                }}
                              >
                                <DeleteIcon color='red' />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>

                <hr />

                <div className='mt-5 mb-4'>
                  <div className='createProductPlan table-title flex justify-between'>
                    <div className='mb-3 text-primary'>Items required to fulfill the plan</div>
                    {tableData.length > 0 && (
                      <div className='action-button flex gap-3'>
                        <button onClick={handleAddToPlan}>
                          <IoCheckmarkDoneSharp /> Done
                        </button>
                        <button id='clear' onClick={() => setTableData([])}>
                          <VscClearAll />
                          Clear
                        </button>
                      </div>
                    )}
                  </div>

                  <Table responsive borderless striped className='product-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Bar Code</th>
                        <th>Name</th>
                        <th>Qty in BOM</th>
                        <th>Qty Required</th>
                        <th>Qty available</th>
                        <th>UOM</th>
                        {/* <th>Unit Cost</th>
                        <th>Sub Total</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData?.length > 0 &&
                        tableData[0]?.prod_profiles?.map((el, index) => {
                          const maxQuantity = currency(el.quantity, {
                            symbol: '',
                          })
                            .multiply(formik.values.Quantity)
                            .format();
                          const blinkRed =
                            Number(el['item_data.Quantity'] || 0) < maxQuantity && 'blink-red';
                          console.log(el)
                          console.log(tableData)
                          return (
                            <tr
                              key={index}
                              className={`${activeTableIndex === index && 'active-row'}`}
                              onClick={() =>
                                activeTableIndex !== index && setActiveTableIndex(index)
                              }
                            >
                              <td>{index + 1}</td>
                              <td>{el.item}</td>
                              <td>{el.title}</td>
                              <td>{el.quantity}</td>
                              <td className={blinkRed}>{maxQuantity}</td>
                              <td>{el['item_data.Quantity'] || 0}</td>
                              <td>{el?.Product_Model}</td>
                              {/* <td>
                              <input
                                className="border-0 text-center"
                                type="number"
                                value={el.Quantity}
                                disabled
                                onKeyDown={(e) =>
                                  e.key === "Enter" && e.target.blur()
                                }
                                name="Quantity"
                                onChange={(e) =>
                                  handleInputChange({
                                    index,
                                    name: e.target.name,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </td>
                            <td>{el?.UnitCost}</td>
                            <td className="d-flex align-items-center">
                              <span>
                                {currency(
                                  parseFloat(el?.UnitCost) *
                                    parseInt(el?.Quantity),
                                  {
                                    symbol: "",
                                  }
                                ).format()}
                              </span>
                              <span
                                className="mx-3 p-cursor"
                                onClick={() => onDelete(el.Bar_Code)}
                              >
                                <DeleteIcon />
                              </span>
                            </td> */}
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>

                {/*  */}

                {errorMessage && (
                  <div className='d-flex justify-content-center'>
                    <p className='text-danger'>
                      <b>{errorMessage}</b>
                    </p>
                  </div>
                )}
                <div className='d-flex gap-2 justify-content-end mt-3'>
                  <button onClick={formik.handleSubmit} className='btn btn-primary'>
                    Submit
                  </button>
                  {/* {props?.choosedItem ? (
                    <button
                      onClick={handleAddToPlan}
                      className='btn btn-secondary'
                      disabled={isLoadingAddToCart || editProductPlan.isLoading}
                    >
                      {isLoadingAddToCart
                        ? 'Checking...'
                        : editProductPlan.isLoading
                        ? 'Sending...'
                        : 'Edit Plan'}
                    </button>
                  ) : (
                    <button
                      onClick={handleAddToPlan}
                      className='btn btn-outline-info'
                      disabled={isLoadingAddToCart || sendProductLog.isLoading}
                    >
                      {isLoadingAddToCart
                        ? 'Checking...'
                        : sendProductLog.isLoading
                        ? 'Sending...'
                        : 'Create Plan'}
                    </button>
                  )} */}

                  {itemsRequested.length > 0 && (
                    <>
                      <button
                        className='btn btn-primary mx-3'
                        onClick={() => setShowNewRequisitionModal(true)}
                      >
                        Request for items
                      </button>
                      <button className='btn btn-primary mx-3' onClick={handleRequisitionRequest}>
                        Purchase Requesition
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <ModalLoader
              show={
                sendProductLog.isLoading ||
                isLoading ||
                isLoadingAddToCart ||
                editProductPlan.isLoading
              }
            />

            {showNewRequisitionModal && (
              <NewRequisitionModal
                modalTitle='Send for Approval'
                defaultFormValues={{
                  title: formik.values.Plan_Name !== '' ? formik.values.Plan_Name : '',
                  description: '',
                  type: 'Material Request',
                }}
                itemsRequested={itemsRequested}
                setShowNewRequisitionModal={setShowNewRequisitionModal}
                /* handleCreatedRequisition={handleCreatedRequisition} */
              />
            )}

            {showPurchaseRequisitionModal && (
              <NewPurchaseRequisitionModal
                previousFormValues={{
                  type: 'Purchase Request',
                  title: formik.values.Plan_Name,
                  requestItems: requisitionData,
                }}
                itemsRequested={requisitionData}
                setShowNewRequisitionModal={setShowPurchaseRequisitionModal}
              />
            )}

            {/*  */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
